import counterUp from 'counterup2';

export default function init() {

    const counters = document.querySelectorAll('[data-counter]');

    const callback = entries => {
        entries.forEach(entry => {
            const el = entry.target;
            if (entry.isIntersecting && !el.classList.contains('is-visible')) {
                for (const counter of counters) {
                    counterUp(counter, {
                        duration: 2000,
                        delay: 4,
                    });
                    el.classList.add('is-visible');
                }
            }
        });
    };

    const IO = new IntersectionObserver(callback, { threshold: 1 });
    const el = document.querySelector('[data-counter]');
    IO.observe(el);
}
